export const DOMAIN_CONFIG = {
  hongkong: 'https://home.powerbank.mykeeta.com/',
  uk: [
    'https://keeta-charging.powerbank.mykeeta.com/',
    'https://keeta-charging.com/',
  ],
};

export function getCountryByDomain(hostname) {
  if (hostname === 'localhost') {
    return 'uk';
  }
  if (hostname.includes('keeta-charging')) {
    return 'uk';
  }
  return 'hongkong'; // 默认英国
}
export function getApiBaseUrl(country) {
  const env = process.env.VUE_APP_ENV;
  if (country === 'hongkong') {
    return env === 'production'
      ? 'https://enter-api.powerbank.mykeeta.com/api-c'
      : 'https://test-enter-api.powerbank.mykeeta.com/api-c';
  }
  if (country === 'uk') {
    return env === 'production'
      ? 'https://enter-api-uk.powerbank.mykeeta.com/api-c'
      : 'https://test-enter-api-uk.powerbank.mykeeta.com/api-c';
  }
}
